import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../useAuth";
import userLogo from "../assets/user.png";
import {
  IoSearch,
  IoApps,
  IoSettingsOutline,
  IoHelpCircleOutline,
  IoLogOutOutline,
} from "react-icons/io5";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    const confirmed = window.confirm("Are you sure you want to Log Out?");
    if (!confirmed) return;
    logout();
  };

  return (
    <div className="flex items-center justify-between px-6 py-3 bg-white border-b border-gray-200 w-full min-h-[64px]">
      {/* Search Bar - Disabled */}
      <div className="flex-1 max-w-3xl">
        <div className="relative group max-w-xl opacity-50 cursor-not-allowed">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
            <IoSearch className="text-gray-400 text-lg" />
          </div>
          <input
            type="text"
            placeholder="Search resources, users, or settings..."
            disabled
            className="block w-full pl-11 pr-4 py-3 border-none rounded-full bg-gray-100 text-gray-400 placeholder-gray-400 cursor-not-allowed focus:outline-none shadow-none text-[15px]"
          />
        </div>
      </div>

      {/* Right Actions */}
      <div className="flex items-center gap-1 sm:gap-2">
        <button
          disabled
          className="p-2.5 text-gray-300 rounded-full cursor-not-allowed transition-colors"
          title="Help"
        >
          <IoHelpCircleOutline className="text-2xl" />
        </button>
        <button
          disabled
          className="p-2.5 text-gray-300 rounded-full cursor-not-allowed transition-colors"
          title="Settings"
        >
          <IoSettingsOutline className="text-2xl" />
        </button>
        <button
          disabled
          className="p-2.5 text-gray-300 rounded-full cursor-not-allowed transition-colors mr-2"
          title="Apps"
        >
          <IoApps className="text-2xl" />
        </button>
        {/* Profile Section */}
        <div className="flex items-center gap-3 pl-2 sm:pl-4 border-l border-gray-200">
          <div
            className="flex items-center gap-3 cursor-pointer p-1.5 rounded-full hover:bg-gray-50 pr-4 transition-all group"
            onClick={() => navigate("./profile")}
          >
            <img
              src={userLogo}
              className="w-9 h-9 rounded-full object-cover border border-gray-200 group-hover:border-blue-300 transition-colors"
              alt="Profile"
            />
            <div className="hidden md:block text-left leading-tight">
              <p className="text-sm font-semibold text-gray-700 group-hover:text-blue-700 transition-colors">
                {user?.fullName || "Administrator"}
              </p>
              <p className="text-[11px] text-gray-500 font-medium">
                {user?.userType || "User"}
              </p>
            </div>
          </div>

          {/* Logout Action */}
          <button
            onClick={handleLogout}
            className="p-2.5 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-full transition-all ml-1"
            title="Sign out"
          >
            <IoLogOutOutline className="text-2xl" />
          </button>
        </div>
      </div>
    </div>
  );
}
